'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _similarItems = require('./remote/similarItems');

var SimilarItems = {
    fetchSimilarItems: _similarItems.SimilarItemsRemote.fetchSimilarItems
};

exports.default = SimilarItems;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/similarItems.js
// module id = ApaR
// module chunks = 60